/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import {assign, Machine} from 'xstate';
import ExtJS from '../../interface/ExtJS';
import UIStrings from '../../constants/UIStrings';

export default Machine(
    {
      initial: 'idle',
      context: {
        userToken: null,
      },
      states: {
        idle: {
          on: {
            ACCESS: 'accessToken',
            RESET: 'resetToken',
          }
        },
        accessToken: {
          invoke: {
            id: 'accessToken',
            src: 'accessToken',
            onDone: {
              target: 'showToken',
              actions: 'setToken'
            },
            onError: {
              target: 'idle',
              actions: 'showAccessError'
            }
          },
        },
        resetToken: {
          invoke: {
            id: 'resetToken',
            src: 'resetToken',
            onDone: {
              target: 'idle',
              actions: 'showResetSuccess'
            },
            onError: {
              target: 'idle',
              actions: 'showResetError'
            }
          }
        },
        showToken: {
          after: {
            60000: 'idle'
          },
          exit: 'unsetToken',
          on: {
            ACCESS: 'accessToken',
            RESET: 'resetToken',
            HIDE: {
              target: 'idle',
              actions: 'unsetToken'
            }
          }
        }
      }
    },
    {
      actions: {
        showResetSuccess: () => {
          ExtJS.showSuccessMessage(UIStrings.USER_TOKEN.MESSAGES.RESET_SUCCESS)
        },
        showResetError: () => {
          ExtJS.showErrorMessage(UIStrings.USER_TOKEN.MESSAGES.RESET_ERROR)
        },
        showAccessError: () => {
          ExtJS.showErrorMessage(UIStrings.USER_TOKEN.MESSAGES.ACCESS_ERROR);
        },
        setToken: assign({
          token: (_, event) => event.data.data
        }),
        unsetToken: assign({
          token: null
        })
      }
    }
);
